import { jwtDecode } from 'jwt-decode';
export default {
  namespaced: true, // Ensure the module is namespaced
  state: () => ({
    token: localStorage.getItem('auth_token') || null, // Load token from localStorage
    user: null,
  }),
  mutations: {
    setToken(state, token) {
      state.token = token;
      localStorage.setItem('auth_token', token); // Save token to localStorage
    },
    setUser(state, user) {
      state.user = user;
    },
    clearAuth(state) {
      state.token = null;
      state.user = null;
      localStorage.removeItem('auth_token'); // Remove token from localStorage
    },
  },
  actions: {
    handleLoginRedirect({ commit }, token) {
      console.log('Dispatching handleLoginRedirect with token:', token);
      localStorage.setItem('auth_token', token); // Save token in localStorage
      commit('setToken', token); // Save token to Vuex state
    },
    saveToken({ commit }, token) {
      commit('setToken', token);
    },
    loadToken({ commit }) {
      const token = localStorage.getItem('auth_token');
      if (token) commit('setToken', token);
    },
    logout({ commit }) {
      commit('clearAuth');
      localStorage.removeItem('auth_token');
    },
  },
  getters: {
    isAuthenticated: (state) => {
      if (!state.token) {
        console.warn('No token found'); // Debug log for missing token
        return false; // Not authenticated
      }
      try {
        const decoded = jwtDecode(state.token); // Decode the JWT
        const isExpired = decoded.exp && Date.now() >= decoded.exp * 1000; // Check expiration
        if (isExpired) {
          console.warn('Token is expired');
          return false; // Token expired
        }
        return true; // Token is valid and not expired
      } catch (err) {
        console.error('Invalid token:', err); // Log decoding errors
        return false; // Invalid token
      }
    },
    getUser: (state) => state.user,
  },
};
